module.exports = __webpack_public_path__ + "static/home.bb27d2f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/buddybet/home.jpg
// module id = ./src/app/data/screenshots/buddybet/home.jpg
// module chunks = 10